import { Outlet } from 'react-router';

export default function AuthenticatedAppLayout() {
    return <Outlet />;
}